'use client';

import { canUseDOM } from '@/app/common/utils/canUseDOM';

type InteractionEventType = {
  event: 'userInteraction';
  user: {
    interaction: {
      category:
        'flight_details' | 'hotel_details' | 'room_details' | 'train_details' | 'recommendation' | 'results-list';
      action: string;
      label: string;
      n: 0 | 1;
    };
  };
};

function trackInteractionEvents(trackingData: InteractionEventType) {
  if (canUseDOM) {
    window.platformData?.push(trackingData);
  }
}

export function trackSocialShare(label: string) {
  trackInteractionEvents({
    event: 'userInteraction',
    user: {
      interaction: {
        category: 'hotel_details',
        action: 'social_share',
        label,
        n: 0,
      },
    },
  });
}

export function trackViewMap() {
  trackInteractionEvents({
    event: 'userInteraction',
    user: {
      interaction: {
        category: 'hotel_details',
        action: 'summary',
        label: 'view_map',
        n: 0,
      },
    },
  });
}

export function trackShowMoreDescription(isOpen: boolean) {
  trackInteractionEvents({
    event: 'userInteraction',
    user: {
      interaction: {
        category: 'hotel_details',
        action: 'read_more',
        label: isOpen ? 'collapse' : 'expand',
        n: 0,
      },
    },
  });
}

export function trackAmenitiesSummaryClick() {
  trackInteractionEvents({
    event: 'userInteraction',
    user: {
      interaction: {
        category: 'hotel_details',
        action: 'summary',
        label: 'show_amenities',
        n: 0,
      },
    },
  });
}

export function trackViewTransportDetailsClick(isTrain: boolean) {
  trackInteractionEvents({
    event: 'userInteraction',
    user: {
      interaction: {
        category: isTrain ? 'train_details' : 'flight_details',
        action: 'summary',
        label: isTrain ? 'view_the_train_details' : 'view_the_flight_details',
        n: 0,
      },
    },
  });
}

export function trackSeeMoreHotels() {
  trackInteractionEvents({
    event: 'userInteraction',
    user: {
      interaction: {
        category: 'hotel_details',
        action: 'tab',
        label: 'see_more_hotels',
        n: 0,
      },
    },
  });
}

export function trackUnavailableRoomsSeeOtherHotels() {
  trackInteractionEvents({
    event: 'userInteraction',
    user: {
      interaction: {
        category: 'room_details',
        action: 'tab',
        label: 'see_more_hotels',
        n: 0,
      },
    },
  });
}

export function trackUnavailableRoomsChangeDates() {
  trackInteractionEvents({
    event: 'userInteraction',
    user: {
      interaction: {
        category: 'room_details',
        action: 'tab',
        label: 'change_dates',
        n: 0,
      },
    },
  });
}

export function trackHotelReviewsLink() {
  trackInteractionEvents({
    event: 'userInteraction',
    user: {
      interaction: {
        category: 'hotel_details',
        action: 'summary',
        label: 'reviews',
        n: 0,
      },
    },
  });
}

export function trackSelectRoomTypeClick() {
  trackInteractionEvents({
    event: 'userInteraction',
    user: {
      interaction: {
        category: 'hotel_details',
        action: 'tabs',
        label: 'select_room_type',
        n: 0,
      },
    },
  });
}

export function trackHotelCardClick(cardNumber: number) {
  trackInteractionEvents({
    event: 'userInteraction',
    user: {
      interaction: {
        category: 'recommendation',
        action: 'recommended_hotels',
        label: `hotel-${cardNumber}`,
        n: 0,
      },
    },
  });
}

export function trackRoomShowDetails(isOpen: boolean) {
  trackInteractionEvents({
    event: 'userInteraction',
    user: {
      interaction: {
        category: 'room_details',
        action: 'show_details',
        label: isOpen ? 'open' : 'close',
        n: 0,
      },
    },
  });
}

export type GaTrackCheckoutLabel = 'card' | 'button-continue' | 'card_selection';

export function trackCheckOut(accommodationOnly: boolean, label: GaTrackCheckoutLabel) {
  trackInteractionEvents({
    event: 'userInteraction',
    user: {
      interaction: {
        category: 'room_details',
        action: accommodationOnly ? 'card-hotel' : 'card-dp',
        label,
        n: 0,
      },
    },
  });
}

export function trackSelectNewTransport(isTrain: boolean) {
  trackInteractionEvents({
    event: 'userInteraction',
    user: {
      interaction: {
        category: 'results-list',
        action: isTrain ? 'card-train' : 'card-flight',
        label: isTrain ? 'choose_train' : 'choose_flight',
        n: 0,
      },
    },
  });
}
